import RadioButton from '@amzn/meridian/radio-button';
import { localizeWithRef } from './localize';

export default localizeWithRef(RadioButton, ['children']);
